import * as React from "react";
import styles from "./Exhibition.module.css";
import {
  Backdrop,
  Box,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import Header from "../../Components/Layout/Header";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import styled from "styled-components";
import ArtworkTab from "../../Components/Tabs/ArtworkTab";
import load from "../Assets/logo/FaamGallery-Page-Loader1-ezgif.com-gif-to-mp4-converter.mp4";
import FavoriteIcon from "@mui/icons-material/Favorite";

import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Parse from "../../API/ParseServer";
import ArtworkCard from "../../Components/ArtworkCard/ArtworkCard";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { Slide } from "react-slideshow-image";
import Footer from "../../Components/Layout/Footer";
import { useCart } from "../../Context/CartContext";
const properties = {
  prevArrow: <ArrowBackIosRoundedIcon className={styles.arrow} />,
  nextArrow: <ArrowForwardIosRoundedIcon className={styles.arrow} />,
};
const Exhibition = () => {
  const params = useParams();
  const [exhibition, setExhibition] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imageCount, setImageCount] = useState(0);
  const [images, setImages] = useState<any[]>();
  const [imagesId, setImageId] = useState("");
  const [selectedImage, setSelectedImage] = useState(0);
  const [artworkIds, setArtworkIds] = useState();
  const [artworks, setArtworks] = useState<any[]>();
  const [isLiked, setIsLiked] = useState();

  useEffect(() => {
    const fetchExhibition = async () => {
      const query = new Parse.Query("Artwall_Exhibition");
      query.equalTo("objectId", params.exhibitionId);
      const user = Parse.User.current();

      try {
        const results = await query.find();
        if (results.length > 0) {
          setExhibition(results[0]);
          setArtworkIds(results[0].get("artworks"));
          const imagesQuery = new Parse.Query("Artwall_ExhibitionImage");
          imagesQuery.equalTo("objectId", results[0].get("images").id);
          try {
            const imageResults = await imagesQuery.find();
            if (imageResults.length > 0) {
              // setArtworkId(results[0].id);
              let imageList = [];
              // imageList.push(thumbnail);
              for (
                let index = 1;
                index <= results[0].get("imageCount");
                index++
              ) {
                imageList.push(imageResults[0].get(`file${index}`).url());
              }
              setImages(imageList);
            } else {
              throw new Error("Artwork Images not found.");
            }
          } catch (err: any) {
            setError(err.message);
          } finally {
            setLoading(false);
          }
          if (user)
            setIsLiked(
              results[0].get("likeUsers")
                ? results[0].get("likeUsers").includes(user.id)
                : false,
            );
        } else {
          throw new Error("Exhibition not found.");
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchExhibition();
  }, [params.exhibitionId]);
  const [artworkChange, setArtworkChange] = useState(false);
  const artworkChangeHandler = () => {
    setArtworkChange((current: any) => !current);
  };
  useEffect(() => {
    const fetchArtworks = async () => {
      const artworkQuery = new Parse.Query("Artwork");
      if (artworkIds) {
        artworkQuery.containedIn("objectId", artworkIds);
        try {
          const artworkResults = await artworkQuery.find();
          if (artworkResults.length > 0) {
            setArtworks(artworkResults);
          } else {
            throw new Error("Artwork Images not found.");
          }
        } catch (err: any) {
          setError(err.message);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchArtworks();
  }, [artworkIds, artworkChange]);
  const [modal, setModal] = React.useState("");
  const handleClose = () => {
    setModal("");
  };
  const handleOpen = (event: any) => {
    setModal(event.target.id);
  };
  const imageClickHandler = (event: any) => {
    console.log(event.target.id);
    setSelectedImage(Number(event.target.id));
  };
  const [basket, setBasket] = useState();
  const [artworkQuantities, setArtworkQuantities] = useState();
  const { setTotalQuantity } = useCart();
  useEffect(() => {
    const fetchBasket = async () => {
      const user = Parse.User.current();

      if (user || localStorage.getItem("guestId")) {
        try {
          const basket = await Parse.Cloud.run("getBasket", {
            user: user ? user.id : localStorage.getItem("guestId"),
          });
          if (basket.get("status") !== "completed") setBasket(basket);
          const artworkQuantities: any = {};
          basket
            .get("items")
            .filter(
              (item: any) =>
                item.type === "ArtworkFrame" || item.type === "Artwork",
            )
            .forEach((item: any) => {
              const artworkId = item.artwork.id;
              artworkQuantities[artworkId] =
                (artworkQuantities[artworkId] || 0) + item.quantity;
            });
          setArtworkQuantities(artworkQuantities);
          let totalQuantity = 0;
          basket.get("items").forEach((item: any) => {
            totalQuantity += item.quantity;
          });
          setTotalQuantity(totalQuantity);
          localStorage.setItem("totalQuantity", String(totalQuantity));
        } catch (error) {
          console.error("Error fetching basket:", error);
        } finally {
          // setLoading(false);
        }
      }
    };
    fetchBasket();
  }, [artworkChange]);
  const [likeError, setLikeError] = useState("");

  const likeHandler = async () => {
    const user = Parse.User.current();
    let response: any;
    if (user) {
      try {
        response = await Parse.Cloud.run("toggleExhibitionLike", {
          exhibitionId: params.exhibitionId,
          userId: user.id,
        });
      } catch (error: any) {
        console.error(error.message);
        alert(error.message);
      } finally {
        if (response) setIsLiked(response.isLiked);
      }
    } else {
      setLikeError("You need to login first!");
      setTimeout(() => {
        setLikeError("");
      }, 1000);
    }
  };
  const copyHandler = () => {
    window.navigator.clipboard.writeText(document.URL);
  };
  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          height: "30rem",
          // backgroundColor: "gray",
          position: "relative",
          // zIndex: "-1",
          // top: "4rem",
        }}
      >
        {exhibition && exhibition.get("banner") && (
          <img
            src={exhibition.get("banner").url()}
            alt="banner"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: -5,
              height: "30rem",
              width: "100%",
            }}
          />
        )}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
            height: "30rem",
            width: "100%",
            backgroundColor: "black",
            opacity: 0.5,
          }}
        ></Box>
        {exhibition && (
          <Container>
            <Box
              sx={{
                color: "white",
                // mt: { xs: 20, md: 30 },
                // mb: { xs: 10, lg: 15 },
                height: "34rem",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography variant="h4" component="h2" sx={{ my: 5 }}>
                {exhibition.get("title")}
              </Typography>

              <Typography variant="h5" component="h2">
                {exhibition.get("startDate").toDateString()} -{" "}
                {exhibition.get("endDate").toDateString()}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ marginTop: 3, fontStyle: "italic" }}
              >
                {exhibition.get("description")}
              </Typography>
              <Box sx={{ marginTop: 1, position: "relative" }}>
                {isLiked ? (
                  <IconButton
                    aria-label="remove to favorites"
                    onClick={likeHandler}
                  >
                    <FavoriteIcon sx={{ color: "#8d462b", fontSize: "35px" }} />
                  </IconButton>
                ) : (
                  <IconButton
                    aria-label="add to favorites"
                    onClick={likeHandler}
                  >
                    <FavoriteBorderOutlinedIcon
                      sx={{ color: "white", fontSize: "35px" }}
                    />
                  </IconButton>
                )}
                {likeError && (
                  <Typography
                    variant="caption"
                    sx={{ position: "absolute", bottom: -13, left: -36 }}
                  >
                    {likeError}
                  </Typography>
                )}
                <IconButton onClick={copyHandler}>
                  <ShareOutlinedIcon
                    sx={{ color: "white", fontSize: "35px" }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Container>
        )}
      </Box>
      {exhibition && (
        <Container>
          <Box
            sx={{
              marginTop: 10,
              borderBottom: "2px solid #dad9da",
              width: "100%",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                display: "inline",
                boxShadow: "0 2px #0a0a0a",
                paddingBottom: "4px",
              }}
            >
              Exhibition Information
            </Typography>
          </Box>
          <Grid container my={3} sx={{ justifyContent: "space-between" }}>
            <Grid item xs={12} md={5}>
              {exhibition.get("information").map((item: string) => (
                <Typography variant="body1">
                  {item}
                  <br />
                </Typography>
              ))}

              <br />
              <Typography variant="h6">
                {exhibition.get("artist")} <br />
              </Typography>
              <br />
              {exhibition.get("biography").map((item: any) => (
                <React.Fragment>
                  <Typography>{item}</Typography>
                  <br />
                  <br />
                </React.Fragment>
              ))}
            </Grid>
            {images && (
              <Grid item xs={12} md={6} sx={{}}>
                <Grid
                  item
                  xs={12}
                  sx={{
                    height: "25rem",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={images[selectedImage]}
                    alt=""
                    style={{
                      height: "90%",
                      objectFit: "contain",
                      maxWidth: "100%",
                      cursor: "pointer",
                    }}
                    id={String(selectedImage)}
                    onClick={handleOpen}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    overflow: "scroll",
                    width: "100%",
                    display: "flex",
                    gap: 2,
                  }}
                >
                  {images.map((image: string, index) => (
                    <img
                      src={image}
                      alt=""
                      className={
                        selectedImage === index
                          ? styles["selected-pic"]
                          : styles["unselected-pic"]
                      }
                      id={String(index)}
                      onClick={imageClickHandler}
                    />
                  ))}
                </Grid>
                <Backdrop
                  sx={(theme) => ({
                    color: "#fff",
                    zIndex: theme.zIndex.drawer + 1,
                  })}
                  open={modal === "" ? false : true}
                  // onClick={handleClose}
                >
                  <Box
                    sx={{
                      backgroundColor: "white",
                      width: { xs: "95vw", lg: "50rem" },
                      // height: { xs: "30rem", lg: "auto" },
                      display: "flex",
                      justifyContent: "space-between",
                      // alignItems: "center",
                      color: "black",
                      py: { md: 5, xs: 2 },
                      px: { md: 8, xs: 4 },
                      position: "relative",
                      flexDirection: "column",
                    }}
                  >
                    <button
                      style={{
                        position: "absolute",
                        right: "3rem",
                        backgroundColor: "transparent",
                        border: "none",
                        cursor: "pointer",
                        top: "2rem",
                      }}
                      onClick={handleClose}
                    >
                      <ClearIcon />
                    </button>

                    <Typography component="h2" variant="h4">
                      Album
                    </Typography>
                    {/* <Typography>
                      Explore a handpicked selection of our previously framed
                      works.
                    </Typography> */}
                    <br />
                    {images && modal && (
                      <Slide
                        slidesToScroll={1}
                        // indicators={indicators}
                        {...properties}
                        // duration={}
                        autoplay={false}
                        transitionDuration={800}
                        defaultIndex={Number(modal)}
                      >
                        {images.map((img: any, index) => (
                          <Box
                            sx={{
                              backgroundColor: "white",
                              padding: "1rem",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              width: "100%",
                              height: "100%",
                            }}
                          >
                            <img
                              src={img}
                              alt=""
                              style={{
                                width: "100%",
                                // aspectRatio: 1,
                                marginBottom: "1rem",
                                // maxWidth: "20rem",
                                cursor: "pointer",
                              }}
                              // id={String(ind)}
                              // onClick={handleOpen}
                            />
                          </Box>
                        ))}
                      </Slide>
                    )}
                  </Box>
                </Backdrop>
              </Grid>
            )}
          </Grid>
          <Box
            sx={{
              borderBottom: "2px solid #dad9da",
              width: "100%",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                display: "inline",
                boxShadow: "0 2px #0a0a0a",
                paddingBottom: "4px",
              }}
            >
              Artworks
            </Typography>
          </Box>
          <Grid container spacing={5} py={2}>
            {artworks ? (
              artworks.map((artwork: any) => (
                <ArtworkCard
                  artwork={artwork}
                  basket={basket}
                  artworkChangeHandler={artworkChangeHandler}
                  artworkQuantities={artworkQuantities}
                  grid={3}
                />
              ))
            ) : (
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Typography>
                  There is no artworks assigned to this Exhibition
                </Typography>
              </Grid>
            )}
          </Grid>
        </Container>
      )}
    </React.Fragment>
  );
};

export default Exhibition;
